import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantWidgetAccessView } from "./TenantWidgetAccessView";
import { TenantWidgetAccessViewStore } from "../../store/TenantWidgetAccessViewStore";
import { useStore } from "../../../../hooks";

export const TenantWidgetAccessViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenantWidgetAccess/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantWidgetAccessViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantWidgetAccessView tenantWidgetAccessViewStore={store} />
      </PageLayout>
    </div>
  );
});
